import React, { createContext, useContext, useState } from "react";

// Create a context for notifications
const NotificationContext = createContext();

// Provider component to wrap the app and give access to the notification state
export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);

  return (
    <NotificationContext.Provider value={{ notification, setNotification }}>
      {children}
    </NotificationContext.Provider>
  );
};

// Custom hook to access notification context
export const useNotification = () => {
  return useContext(NotificationContext);
};
